import React from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import { rel } from '../../../../../utils/rel';
import PropTypes from 'prop-types';
import { handleAd } from '../../../../../utils/handleAd';

class TxtInfo extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        ad: PropTypes.object,
    };
    state = {
        typeAllData: {},
    };

    async componentDidMount() {
        const callbackFn = await handleAd(this.props.ad.txtInfo03Ad);
        const callbackFn1 = await handleAd(this.props.ad.txtInfo04Ad);

        callbackFn(this.refs.txtInfo, this.props.ad.txtInfo03Ad.data);
        callbackFn1(this.refs.txtInfo, this.props.ad.txtInfo04Ad.data);
    }

    render() {
        const { txtNewsInfo, txtEditInfo } = this.props.content;
        const { typeAllData } = this.state;

        if (txtEditInfo && txtEditInfo.length > 0) {
            if (txtEditInfo.length < 2) {
                txtNewsInfo.splice(0, 1, txtEditInfo[0]);
            } else {
                txtNewsInfo.splice(0, 2, txtEditInfo[0], txtEditInfo[1]);
            }
        }

        return (
            <div className={styles.img_ad_b}>
                <ul ref="txtInfo">
                    {txtNewsInfo.map((item, index) => (
                        <li key={index}>
                            <a href={item.url} target="_blank" rel={rel}>
                                {item.title2 ? item.title2 : item.title}
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        );
    }
}

export default errorBoundary(TxtInfo);
